import React, { Component } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import PageHeading from "../../../componentes/Comunes/PageHeading";
import ParametrosConsultaEliminadas from "../../../componentes/Autorizaciones/ConsultaEliminadas/ParametrosConsultaEliminadas";


export default class ConsultaEliminadas extends Component{
  constructor(props){
      super(props);
      this.state= {
          Titulo:"Consulta de Autorizaciones Eliminadas"
      }

     
  }


  render() {
      return (
        <Layout>
          <div>
            {/* <!-- Page Heading --> */}
            <PageHeading title="Consulta de Autorizaciones Eliminadas" />
            <ParametrosConsultaEliminadas />
          </div>
        </Layout>
      );
    }

  

}